// extracted by mini-css-extract-plugin
module.exports = {"container":"_2A5NleOPowz0iWznE8mps1","heading":"_3TIcK_--JFCXpTJUPwKETq","requiredLabel":"_3jszGkc16LfRN37qU9ibef","items":"_3mm6x9dWh6G_3mTGdj8WsN"};